
import React, { useRef, useEffect } from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { AIMessage } from '@/contexts/ai-assistant/types';
import MessageItem from './MessageItem';

interface MessageListProps {
  messages: AIMessage[];
  rateResponse: (messageId: string, rating: 'helpful' | 'not-helpful') => void;
  onSourceClick: (url: string) => void;
}

const MessageList: React.FC<MessageListProps> = ({
  messages,
  rateResponse,
  onSourceClick
}) => {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <ScrollArea className="flex-1 pr-4">
      <div className="space-y-4 py-4">
        {messages.map((message) => (
          <MessageItem 
            key={message.id} 
            message={message} 
            rateResponse={rateResponse}
            onSourceClick={onSourceClick}
          />
        ))}
        <div ref={messagesEndRef} />
      </div>
    </ScrollArea>
  );
};

export default MessageList;
